





















import {
    Prop,
    Component,
    Vue,
    Inject,
    InjectReactive,
} from "vue-property-decorator";
import AbcButton from "../button/AbcButton.vue";

@Component({
    components: {
        AbcButton
    }
})
export default class AbcStepButtons extends Vue {
    @InjectReactive() curStep!: number;
    @InjectReactive() numberOfSteps!: number;
    @InjectReactive() isVertical!: boolean;
    @Inject() changeStep!: (step: number) => void;

    @Prop({ type: Boolean }) isOptional!: boolean;
    @Prop({ type: Boolean }) complete!: boolean;
    @Prop({ type: String }) onBackLabel!: string;
    @Prop({ type: String }) onNextLabel!: string;
    @Prop({ type: String }) onSkipLabel!: string;
    
    private onNext() {
        this.changeStep(this.curStep + 1);
        this.$emit("next");
    }

    private onOptional() {
        this.changeStep(this.curStep + 1);
        this.$emit("optional");
    }
}
